import React from 'react'

import {
    CheckboxesContainer
} from './Dropdown.styles'

import {ReactComponent as UnFilledCircle} from "images/unfilledCircle.svg";
import {ReactComponent as FilledCircle} from "images/filledCircle.svg";

interface DropdownProps {
    className: string,
    options: string[],
    selected: number,
    setSelected: (val: number) => void,
    applyFilters: () => void,
    clearFilter: () => void,
    type: string,
}

const Dropdown = ({className, options, selected, setSelected, applyFilters, type, clearFilter}: DropdownProps): JSX.Element | null => {
    return (options?.length ? <CheckboxesContainer className={className + ' visible'}>
        <div className="checkboxes">
            {options.map((option, index) => {
                return (
                    <div className={'list'} key={option} onClick={() => setSelected(index)}>
                        {selected === index
                            ? <FilledCircle/>
                            : <UnFilledCircle/>}
                        <div className='option'>{option}</div>
                    </div>
                )
            })}
        </div>
        <div className="bottomLabel">
            <button className="buttonWhite" onClick={clearFilter}>Clear</button>
            <button className="buttonBigBlue" onClick={applyFilters}>{type === 'sort' ? 'Apply Sorting' : 'Apply Filter'}</button>
        </div>
    </CheckboxesContainer> : null)
}

export default Dropdown;
